const styles = theme => ({
  tooltip: {
    marginTop: theme.spacing(1),
    fontSize: 12
  },
  alert: {
    alignItems: 'flex-start'
  },
  moreIconButton: {
    color: 'inherit',
    marginLeft: theme.spacing(1),
    padding: 0
  }
})

export default styles
